export default {"src":"/_next/static/media/claim.e7401192.svg","height":16,"width":136,"blurWidth":0,"blurHeight":0};